import React from "react";
import { connect } from "react-redux";
import { Flex, SVGButton, TextInput } from "/app/src/component";

import CompanyModel from "/app/src/model/Company/model";

import { companySelector } from "/app/src/selectors";

import EmployeeDetails from "./EmployeeDetails";

class CompanyDetails extends React.Component {
  constructor(props) {
    super(props);
    let today = new Date();
    // add 2 weeks to trial
    today.setDate(today.getDate() + 14);
    let formatDate = `${today.getFullYear()}-${
      today.getMonth() + 1
    }-${today.getDate()}`;
    this.state = {
      trialExtendDate: formatDate,
    };
    this.renderChangePaymentStatus = this.renderChangePaymentStatus.bind(this);
  }

  renderInfo(label, info, width) {
    return (
      <Flex w={width} padding="5px" shrink={0} column>
        <Flex fontWeight="bold"> {label} </Flex>
        <Flex> {info} </Flex>
      </Flex>
    );
  }

  renderChangePaymentStatus() {
    let { selected, companies } = this.props;
    let company = companies[selected];

    const Cancel = {
      text: "cancel",
      border: true,
      padding: "5px",
      margin: "5px",
      confirmationContent: (
        <Flex column>
          <Flex borderBottom="1px solid grey"> Sätt företag till cancel</Flex>
          <Flex py="5px"> name: {company.name}</Flex>
          <Flex py="5px"> id: {company.id}</Flex>
        </Flex>
      ),
      onClick: () => {
        this.props.dispatch(
          CompanyModel.updatePaymentStatus(company.id, "cancel", "whatever")
        );
      },
    };

    const Delete = {
      text: "delete",
      border: true,
      padding: "5px",
      margin: "5px",
      confirmationContent: (
        <Flex column>
          <Flex borderBottom="1px solid grey">
            Vill du tar bort denna företag
          </Flex>
          <Flex py="5px"> name: {company.name}</Flex>
          <Flex py="5px"> id: {company.id}</Flex>
        </Flex>
      ),
      onClick: () => {
        this.props.dispatch(CompanyModel.delete(company.id));
      },
    };
    const TrialDate = {
      text: "Update Trial Date",
      border: true,
      padding: "5px",
      margin: "5px",
      confirmationContent: (
        <Flex column>
          <Flex borderBottom="1px solid grey">
            Change trial date, the preset is 14 days forward
          </Flex>
          <Flex py="5px"> {company.name}</Flex>
          <TextInput
            value={this.state.trialExtendDate}
            onChange={(e) => {
              this.setState({ trialExtendDate: e.target.value });
            }}
          />
        </Flex>
      ),
      onClick: () => {
        this.props.dispatch(
          CompanyModel.setTrialDate(company.id, this.state.trialExtendDate)
        );
      },
    };

    return (
      <Flex wrap>
        <SVGButton {...Delete} />
        <SVGButton {...Cancel} />
        <SVGButton {...TrialDate} />
      </Flex>
    );
  }
  render() {
    let { selected, companies } = this.props;

    if (!companies || !companies[selected]) {
      return "";
    }

    let company = companies[selected];
    return (
      <Flex grow h="100%" column>
        <Flex>
          {this.renderInfo("id", company.id)}
          {this.renderInfo("namn", company.name)}
        </Flex>

        <Flex>
          {this.renderInfo(
            "payment state",
            companySelector.getPaymentStatus(company)
          )}
          {["trial"].includes(companySelector.getPaymentStatus(company)) &&
            this.renderInfo(
              "days left",
              company.payment_status.days_left_in_trial
            )}
        </Flex>
        {this.renderChangePaymentStatus()}

        <Flex wrap={true}>
          {company.employees
            .sort((e1, e2) => e1.id - e2.id)
            .map((emp) => {
              return (
                <EmployeeDetails
                  key={emp.id}
                  employee={emp}
                  companyId={company.id}
                />
              );
            })}
        </Flex>
      </Flex>
    );
  }
}

export default connect((state) => {
  return {};
})(CompanyDetails);



// WEBPACK FOOTER //
// src/layout/Dashboard/MainPanel/Overview/CompanyDetails.js